import { gql } from "@apollo/client";

// Fragment to ensure consistency in form data
export const FORM_FIELDS_FRAGMENT = gql`
  fragment FormFields on Form {
    _id
    name
    eventId
    isDefault
    status
    description
    createdAt
    updatedAt
    answerCount
  }
`;

// Queries
export const GET_ROUTING_FORMS = gql`
  query GetAllRoutingForms($spaceId: ID) {
    getAllRoutingForms(spaceId: $spaceId) {
      _id
      name
      description
      status
      spaceId
      fields
      routes
      fallback
      emailSettings
      createdAt
      updatedAt
    }
  }
`;

// Temporary debug query to see all forms
export const GET_ALL_FORMS_DEBUG = gql`
  query GetAllFormsDebug {
    getAllForms {
      _id
      name
      eventId
      description
    }
  }
`;

export const GET_ROUTING_FORM = gql`
  query GetRoutingForm($id: ID!, $spaceId: ID) {
    getRoutingForm(id: $id, spaceId: $spaceId) {
      _id
      name
      description
      status
      spaceId
      createdAt
      updatedAt
      routes
      fallback
      fields
    }
  }
`;

export const GET_EVENT_FORMS = gql`
  query GetEventForms($eventId: ID!) {
    getEventForms(eventId: $eventId) {
      ...FormFields
    }
  }
  ${FORM_FIELDS_FRAGMENT}
`;

export const GET_FORM_ANSWERS = gql`
  query GetFormAnswers($formId: ID!) {
    getFormAnswers(formId: $formId) {
      _id
      formId
      answers
      attendeeId
      status
      createdAt
      updatedAt
    }
  }
`;

// Mutations
export const SAVE_ROUTING_FORM = gql`
  mutation CreateRoutingForm($input: RoutingFormInput!) {
    createRoutingForm(input: $input) {
      _id
      name
      description
      status
      spaceId
      fields
      routes
      fallback
      emailSettings
      createdAt
      updatedAt
    }
  }
`;

export const UPDATE_ROUTING_FORM = gql`
  mutation UpdateRoutingForm($id: ID!, $input: RoutingFormInput!) {
    updateRoutingForm(id: $id, input: $input) {
      _id
      name
      description
      status
      createdAt
      updatedAt
      routes
      fallback
      fields
    }
  }
`;

export const UPDATE_ROUTING_CONFIG = gql`
  mutation UpdateRoutingConfig($id: ID!, $routes: JSON!, $fallback: JSON) {
    updateRoutingConfig(id: $id, routes: $routes, fallback: $fallback) {
      ...FormFields
      formData
    }
  }
  ${FORM_FIELDS_FRAGMENT}
`;

export const UPDATE_FORM_FIELDS = gql`
  mutation UpdateFormFields($id: ID!, $fields: JSON!) {
    updateFormFields(id: $id, fields: $fields) {
      ...FormFields
      formData
    }
  }
  ${FORM_FIELDS_FRAGMENT}
`;

export const DELETE_ROUTING_FORM = gql`
  mutation DeleteRoutingForm($id: ID!) {
    deleteRoutingForm(id: $id)
  }
`;

export const ARCHIVE_ROUTING_FORM = gql`
  mutation ArchiveRoutingForm($id: ID!) {
    archiveRoutingForm(id: $id) {
      _id
      name
      description
      status
      createdAt
      updatedAt
      routes
      fallback
      fields
    }
  }
`;

export const SAVE_FORM_ANSWER = gql`
  mutation SaveFormAnswer($input: AnswerInput!) {
    saveAnswer(input: $input) {
      _id
      formId
      answers
      attendeeId
      status
      createdAt
      updatedAt
    }
  }
`;

// For fetching events and event types (for routing destinations)
export const GET_EVENT_TYPES = gql`
  query GetEventTypes {
    getEventTypes {
      id
      title
      url
      description
      duration
    }
  }
`;

export const GET_EVENTS = gql`
  query GetEvents {
    getAllEvents {
      id
      name
      startDate
      endDate
    }
  }
`;

// Process a routing form submission to determine destination
export const PROCESS_ROUTING_FORM = gql`
  query ProcessRoutingForm($formId: ID!, $answers: JSON!) {
    processRoutingForm(formId: $formId, answers: $answers) {
      routeMatched
      destination {
        type
        value
        customEventValue
      }
      answerId
    }
  }
`;
